import { Stack } from '@mui/system';
import { RefObject } from 'react';
import { createPortal } from 'react-dom';

import { Button } from '@/components/form/baseInputs/Button';
import { useCanEditDispositiveProvisions } from '@/modules/authentication/hooks/useCanEditDispositiveProvisions';
import { DispositiveProvisionsFormVariant } from '@/modules/dispositiveProvisions/contexts/dispositiveProvisions.context';
import { EditEntitySection } from '@/modules/entities/EditEntitySplitScreen/EditEntitySplitScreen.types';
import { EditEntitySplitScreenFooterRightActions } from '@/modules/entities/EditEntitySplitScreen/EditEntitySplitScreenFooter';

interface DispositiveProvisionsFormV2ModalFooterProps {
  formVariant: DispositiveProvisionsFormVariant;
  footerRef: RefObject<HTMLDivElement | null>;
  handleEditEntitySplitScreenOnSubmit: (
    afterSubmitSection?: EditEntitySection
  ) => void;
  onClose: () => void;
  isSubmitting: boolean;
  onSubmit: () => void;
}

export function DispositiveProvisionsFormV2ModalFooter({
  formVariant,
  footerRef,
  handleEditEntitySplitScreenOnSubmit,
  onClose,
  isSubmitting,
  onSubmit,
}: DispositiveProvisionsFormV2ModalFooterProps) {
  const canEditHouseholdData = useCanEditDispositiveProvisions();
  return (
    <>
      {footerRef.current &&
        createPortal(
          formVariant === 'editEntity' ? (
            <EditEntitySplitScreenFooterRightActions
              onSubmit={handleEditEntitySplitScreenOnSubmit}
            />
          ) : (
            <Stack direction="row" spacing={1}>
              <Button
                variant="secondary"
                size="sm"
                onClick={() => onClose()}
                disabled={isSubmitting}
              >
                {canEditHouseholdData ? 'Cancel' : 'Close'}
              </Button>
              {canEditHouseholdData && (
                <Button
                  variant="primary"
                  size="sm"
                  type="submit"
                  onClick={onSubmit}
                  loading={isSubmitting}
                >
                  Save changes
                </Button>
              )}
            </Stack>
          ),
          footerRef.current
        )}
    </>
  );
}
